import { render, staticRenderFns } from "./ProductionOrderDetail.vue?vue&type=template&id=145c722a&scoped=true&"
import script from "./ProductionOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrderDetail.vue?vue&type=style&index=0&id=145c722a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c722a",
  null
  
)

export default component.exports